"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Comment = exports.CommentBaseProperties = void 0;
var account_1 = require("../account");
var thread_1 = require("./thread");
exports.CommentBaseProperties = ['id', 'thread_id', 'author_id', 'reply_comment_id', 'reply_user_id', 'text', 'published_at', 'visit_info', 'stats', 'permalink'];
var Comment = /** @class */function () {
  function Comment(values) {
    if (values === void 0) {
      values = {};
    }
    var properties = exports.CommentBaseProperties;
    var instance = this;
    properties.forEach(function (p) {
      if (p in values) {
        instance[p] = values[p];
      }
    });
    if ('thread' in values) {
      instance.thread = new thread_1.Thread(values.thread);
    }
    if ('author' in values) {
      instance.author = new account_1.User(values.author);
    }
    if ('reply_user' in values) {
      instance.reply_user = new account_1.User(values.reply_user);
    }
  }
  return Comment;
}();
exports.Comment = Comment;
